import React from 'react';
import ReactDOM from 'react-dom';
import ManualEventForm from './ManualEventForm';

// Modal styles
const modalStyles = `
.create-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
  padding-top: 12vh;
  overflow-y: auto;
}

.create-modal-container {
  background-color: transparent;
  border-radius: 20px;
  max-width: 550px;
  width: 90%;
  position: relative;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .create-modal-overlay {
    padding-top: 5vh;
    align-items: flex-start;
  }
  
  .create-modal-container {
    width: 98%;
    max-height: 85vh;
    margin-bottom: 30px;
  }
}
`;

const CreateEventModal = ({ isOpen, onClose, onAddEvent, API_KEY, initialDate, initialHour }) => {
  if (!isOpen) return null;

  // Handle event creation
  const handleAddEvent = (eventData) => {
    onAddEvent(eventData);
    onClose(); // Close modal after adding event
  };

  // Handle click outside modal
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <>
      <style>{modalStyles}</style>
      <div className="create-modal-overlay" onClick={handleOverlayClick}>
        <div className="create-modal-container">
          <ManualEventForm
            onAddEvent={handleAddEvent}
            API_KEY={API_KEY}
            eventToEdit={null}
            initialDate={initialDate}
            initialHour={initialHour}
            onClose={onClose}
          />
        </div>
      </div>
    </>,
    document.body
  );
};

export default CreateEventModal;